var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"favorite-search-icon",attrs:{"aria-hidden":"true"}},[_c('v-icon',{attrs:{"size":"22"}},[_vm._v("mdi-magnify")]),_c('v-icon',{staticClass:"favorite-search-heart",attrs:{"size":"12"}},[_vm._v("mdi-heart")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }